import flagUs from "assets/images/flags/20/us.svg";
import flagspain from "assets/images/flags/20/es.svg";

const languages = {
  sp: {
    label: "Español",
    flag: flagspain,
  },
  en: {
    label: "English",
    flag: flagUs,
  },
};

export default languages;
